import { DropDownList } from "@progress/kendo-react-dropdowns"
import { InputHLPure, CheckBoxHLPure, DataPickerHLPure } from "../../pures"
import { Grid } from "@material-ui/core";
import { BtnAddSurvey, BtnRemoveSurvey } from "../../../assets/logos/icons";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

const QuestionEditable = (props) => {
  let { id, setTypeQuestion, data, handleChangeQuestion, editQuestionOptions, handleChangeQuestionOption, handleOptionDropDown, createNewQuestion, typeQuestion, handleChangeConfig } = props

  const defaultValue = typeQuestion.find((element) => element.id === data.typeQuestionId)
  const { t: transl } = useTranslation('survey', { keyPrefix: 'surveyDetails' })
  const { t: tCommon } = useTranslation('common')

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={9}>
          <InputHLPure
            labelInput={transl("question")}
            typeInput={"text"}
            valueInput={data.name}
            handleChangeInput={(e) => handleChangeQuestion(e)}
            inputActive
          />
        </Grid>
        <Grid item xs={3}>
          <label className="eticket-form-label" name="label">{transl("questionType")}</label>
          <DropDownList
            className="eticket-dropdown-field"
            data={typeQuestion?.length > 0 ? typeQuestion.map((type) => type.name) : []}
            defaultValue={tCommon(defaultValue?.name)}
            onChange={(event) => {
              const selectedAttribute = typeQuestion.find((element) => element.name === event.target.value)
              setTypeQuestion(selectedAttribute.id)
            }}
          />
        </Grid>
        {
          (data.typeQuestionId === 1) &&
          <Grid item xs={7} style={{ paddingTop: 0 }}>
            <InputHLPure
              labelInput={transl("questionType1Title")}
              typeInput={"text"}
              valueInput={data.config.maxCharacters}
              handleChangeInput={(e) => handleChangeConfig(e.target.value, 'maxCharacters')}
              inputActive
            />
          </Grid>
        }
        {
          (data.typeQuestionId === 2) &&
          <>
            <Grid item xs={6} style={{ paddingTop: 0 }}>
              <InputHLPure
                labelInput={transl("questionType2-5Title1")}
                typeInput={"number"}
                valueInput={data.config.minNum}
                handleChangeInput={(e) => handleChangeConfig(e.target.value, 'minNum')}
                inputActive
              />
            </Grid>
            <Grid item xs={6} style={{ paddingTop: 0 }}>
              <InputHLPure
                labelInput={transl("questionType2-5Title2")}
                typeInput={"number"}
                valueInput={data.config.maxNum}
                handleChangeInput={(e) => handleChangeConfig(e.target.value, 'maxNum')}
                inputActive
              />
            </Grid>
          </>
        }
        {
          ([3, 4].includes(data.typeQuestionId) && data.questionOptions) &&
          <>
            {
              data.questionOptions.map((value, key) => {
                return (
                  <>
                    <Grid item xs={1} style={{ display: 'flex', alignItems: 'center' }}>
                      <span>{key + 1}.</span>
                    </Grid>
                    <Grid item xs={10}>
                      <InputHLPure
                        labelInput={transl("questionOptionsTitle")}
                        typeInput={"text"}
                        valueInput={value}
                        handleChangeInput={(e) => handleChangeQuestionOption(key, e.target.value)}
                        inputActive
                      />
                    </Grid>
                    <Grid item xs={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <button style={{ all: "unset" }} onClick={() => editQuestionOptions('subs', key)}><img alt="add-question" src={BtnRemoveSurvey} /></button>
                    </Grid>
                  </>
                )
              })
            }
          </>
        }
        {
          [3, 4].includes(data.typeQuestionId) &&
          <>
            <label style={{ paddingLeft: '12px' }} className="eticket-form-label" name="label">{transl("questionType3-4Title")}</label>
            <Grid item xs={11}>
              <InputHLPure
                typeInput={"text"}
                valueInput={data.optionDropDown ? data.optionDropDown : undefined}
                handleChangeInput={(e) => handleOptionDropDown(e.target.value)}
                inputActive
              />
            </Grid>
            <Grid item xs={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <button style={{ all: "unset" }} onClick={() => editQuestionOptions('sum')}><img alt="add-question" src={BtnAddSurvey} /></button>
            </Grid>
          </>

        }
        {
          (data.typeQuestionId === 5) &&
          <>
            <Grid item xs={6} style={{ paddingTop: 0 }}>
              <DataPickerHLPure className="element"
                stylePicker={{ marginBottom: '16px' }}
                labelDataPicker={transl('questionType2-5Title1')}
                valueDate={data.config.minDate}
                handleChangeDate={(e) => handleChangeConfig(e.target.value, 'minDate')}
              />
            </Grid>
            <Grid item xs={6} style={{ paddingTop: 0 }}>
              <DataPickerHLPure className="element"
                stylePicker={{ marginBottom: '16px' }}
                labelDataPicker={transl('questionType2-5Title2')}
                valueDate={data.config.maxDate}
                handleChangeDate={(e) => handleChangeConfig(e.target.value, 'maxDate')}
              />
            </Grid>
          </>
        }
      </Grid>

      <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
        <div style={{ display: 'flex' }}>
          {
            data.typeQuestionId === 2 &&
            <>
              <div style={{ boxSizing: 'border-box', paddingRight: '24px', display: 'flex', justifyContent: 'center' }}>
                <CheckBoxHLPure
                  labelCheckBox={transl("questionOption1")}
                  valueCheckBox={'Numero entero'}
                  onChangeHandler={() => handleChangeConfig(!data.config.wholeNumber, 'wholeNumber')}
                  checkedState={data.config.wholeNumber}
                />
              </div>
            </>
          }
          {
            data.typeQuestionId === 5 &&
            <>
              <div style={{ boxSizing: 'border-box', paddingRight: '24px', display: 'flex', justifyContent: 'center' }}>
                <CheckBoxHLPure
                  labelCheckBox={transl("questionType5Title1Date")}
                  valueCheckBox={'Fecha'}
                  onChangeHandler={() => handleChangeConfig(!data.config.date, 'date')}
                  checkedState={data.config.date}
                />
              </div>
              <div style={{ boxSizing: 'border-box', paddingRight: '24px', display: 'flex', justifyContent: 'center' }}>
                <CheckBoxHLPure
                  labelCheckBox={transl("questionType5Title2Time")}
                  valueCheckBox={'Hora'}
                  onChangeHandler={() => handleChangeConfig(!data.config.hour, 'hour')}
                  checkedState={data.config.hour}
                />
              </div>
            </>
          }
        </div>
        <div style={{ display: 'flex' }}>
          <div style={{ boxSizing: 'border-box', paddingRight: '24px', display: 'flex', justifyContent: 'center' }}>
            <CheckBoxHLPure
              labelCheckBox={transl("questionOption2")}
              valueCheckBox={'Obligatoria'}
              onChangeHandler={() => handleChangeConfig(!data.config.required, 'required')}
              checkedState={data.config.required}
            />
          </div>
          <div style={{ boxSizing: 'border-box' }}>
            <button style={{ marginTop: 0 }} className="buttonHLPure buttonHLPure-primary outlined space-button" onClick={createNewQuestion}>{transl("addQuestionButton")}</button>
          </div>
        </div>
      </div>
    </>
  )
}

export default QuestionEditable